export { SkeletonCard } from './SkeletonCard';
export type { SkeletonCardProps, SkeletonCardVariant } from './SkeletonCard.types';
